<template>
  <a
    v-if="external"
    :href="to"
    class="navbar-link"
    :target="openInNewTab ? '_blank' : '_top'"
  >
    <slot /><font-awesome-icon class="mt-1" icon="chevron-right" />
  </a>
  <div v-else-if="children?.length > 0">
    <router-link
      class="navbar-link"
      :to="to"
    >
      <slot /><font-awesome-icon class="mt-1" icon="chevron-right" />
    </router-link>
    <router-link
      v-if="ParentIsActive"
      v-for="child in children"
      :key="child.name"
      :to="child.path"
      class="navbar-link child"
    >
      {{ child.name }}<font-awesome-icon class="mt-1" icon="chevron-right" />
    </router-link>
  </div>
  <router-link
    v-else
    class="navbar-link"
    :to="to"
  >
    <slot /><font-awesome-icon class="mt-1" icon="chevron-right" />
  </router-link>
</template>
<script lang="ts" setup>
import { useRoute } from "vue-router";
import { computed, PropType } from "vue";
import { Issue } from "@/models/issue";

interface Child {
  name: string;
  path: string;
}

const props = defineProps({
  to: {
    type: String,
    required: true
  },
  external: Boolean,
  openInNewTab: Boolean,
  children: {
    type: Array as PropType<Child[]>,
    default: () => []
  }
});

const route = useRoute();

// route begins with the parent path
const ParentIsActive = computed(() => {
  return route.path.startsWith(props.to) || props.children?.some((child) => route.path.startsWith(`${child.path}`))
});
</script>

<style lang="postcss">
.navbar-link {
  background: #f9fafb;
  @apply flex justify-between py-4 px-6 border-b border-r;
}
.navbar-link.router-link-active {
  @apply bg-white border-r-0 border-b border-primary text-primary;
}

.navbar-link.child {
  @apply flex bg-white justify-between py-4 px-6 pl-10 border-b border-r;
}
.navbar-link.router-link-active.child {
  @apply bg-white border-r-0 border-b border-primary text-primary;
}
</style>
